import axios from 'axios';
import Cookies from 'js-cookie';

const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

http.interceptors.request.use((config) => {
  const accessToken = Cookies.get('token');
  if (accessToken) {
    config.headers.Authorization = `${accessToken}`;
  }
  return config;
});


http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      Cookies.remove('token');
      localStorage.clear();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default http;
